export const SITE = {
  name: "ECO-GEST PATRIMOINE",
  legalName: "ECO-GEST PATRIMOINE SAS",
  slogan: "CONSTRUISONS ET GÉRONS ENSEMBLE L'AVENIR",
  tagline:
    "Économie de la Construction — Maîtrise d'Œuvre d'Exécution — OPC",
  description:
    "Un accompagnement rigoureux et personnalisé pour la réussite de vos projets de construction.",
  logo: "/logo.png",
  // Image containing BOTH logos side-by-side (left = for light bg, right = white version for dark bg)
  // We'll use it with object-position right to crop to the white-on-dark version in Footer & dark sections
  logoDualSheet: "/logo.png",
  contact: {
    address: "10 impasse de la Maison Blanche, 74150 Marigny-Saint-Marcel",
    phone: "06 60 81 65 49",
    whatsapp: "33660816549",
    email: "contact@ecogest-patrimoine.fr",
    hours: "Lundi — Vendredi · 9h00 — 18h00",
    zone: "Haute-Savoie, Savoie, Ain & région Auvergne-Rhône-Alpes — interventions sur toute la France pour les opérations à forte valeur ajoutée",
  },
  social: {
    linkedin: "#",
  },
  mapEmbed:
    "https://www.google.com/maps?q=10+impasse+de+la+Maison+Blanche+74150+Marigny-Saint-Marcel&output=embed&z=15",
};
